import { ReactElement, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Container } from "reactstrap";
import useDeleteItem from "@hooks/Shared/useDeleteItem";
import deleteClient from "@services/Core/ClientManager/deleteClient";
import useListColumns from "@hooks/Security/Clients/useListColumns";
import { EUiStates } from "@constants/enum";
import ModalConfirmation from "@components/ModalConfirmation";
import Title from "@components/Title";
import Table from "@components/Table";
import Loader from "@components/Loader";
import CreateBtn from "@components/CreateButton";
import useListItems from "@hooks/Shared/useListItems";
import getClients from "@services/Core/ClientManager/getClients";
import listClientsMapper from "@mappers/Security/Clients/ListClient.mapper";

const ListClients = (): ReactElement => {
  const { t } = useTranslation(["core"]);
  const [isDeletingItem, setIsDeletingItem] = useState(false);
  const { isLoading, basicData, tableItems } = useListItems(
    isDeletingItem,
    getClients,
    listClientsMapper,
    true
  );
  const { isModalOpen, isDeleting, handleDelete, handleIsModalOpen } =
    useDeleteItem(basicData);
  const COLUMNS = useListColumns();

  useEffect(() => {
    setIsDeletingItem(isDeleting);
  }, [isDeleting]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <Container>
      <ModalConfirmation
        icon="trash"
        title={`${t("core:common.clients")} | ${t(
          "core:common.delete_confirm"
        )}`}
        body={`${t("core:notifications.delete_message")} "${
          basicData?.text
        }" ?`}
        handleConfirm={() => {
          handleDelete(deleteClient);
        }}
        handleModalStatus={handleIsModalOpen}
        modalStatus={isModalOpen}
        modalType={EUiStates.DANGER}
      />
      <Title />
      <CreateBtn />
      <Table columns={COLUMNS} items={tableItems} />
    </Container>
  );
};

export default ListClients;
